import { ReactNode, createContext, useContext } from 'react';

import { CommentModel, CommentParentEntity } from '~/modules/comments/libs/types';

interface CommentsContextValue {
  parentId: string;
  parentEntity: CommentParentEntity;
  data?: CommentModel[];
  isLoading?: boolean;
  refetch?: () => Promise<unknown>;
}

export const CommentsContext = createContext<CommentsContextValue>({
  parentId: '',
  parentEntity: 'COMMENT',
});

interface CommentsProviderProps {
  children: ReactNode;
  parentId: string;
  parentEntity: CommentParentEntity;
  data?: CommentModel[];
  isLoading?: boolean;
  refetch?: () => Promise<unknown>;
}

export const CommentsProvider = (props: CommentsProviderProps) => {
  const { children, ...args } = props;

  return <CommentsContext.Provider value={{ ...args }}>{children}</CommentsContext.Provider>;
};

export const useCommentsContext = () => useContext(CommentsContext);
